/* velocco-gift-guard v2.0.0 — 2026-09-29
 * v2.0.0 — Hushlight → Hearthwrap: ana ürün bornoz + Winter Warm Set, add-on eşlemesi
 *          çorap / el ısıtıcı / powerbank (sepet fiyatı → normal fiyatlı ürün).
 * Öksüz hediye koruması: ana ürün (Hushlight 650) sepetten çıkarılınca 0₺ hediye
 * satırı sepette kalıyordu ve tek başına sipariş edilebiliyordu (canlıda ölçüldü).
 * MENAKS'ta yalnız EŞİK hediyesi için temizlik var (menaks-cart-boost.js
 * `syncThresholdGift`); PAKET kademesi hediyesi (landing-atc-handler.js, _gift
 * property) için yok. Bu dosya o boşluğu velocco'da kapatır.
 *
 * v1.9.0 — BOŞ SEPET GÖRÜNÜMÜ: Dawn boş çekmeceyi `<cart-drawer class="is-empty">`
 * sınıfıyla çiziyor (assets/component-cart-drawer.css:47), ama `renderContents`
 * bu sınıfı yalnızca KALDIRIYOR (assets/cart-drawer.js:80-81) — son ürün silinince
 * çekmece bomboş bir panel olarak kalıyordu. Artık sepet boşalınca `is-empty`
 * sınıfı `cart-drawer` ve `cart-drawer-items` üzerine geri konuyor.
 *
 * v1.8.0 — DAVRANIŞ DEĞİŞTİ (Mehmet, 2026-09-24): ana ürün çıkınca yarı fiyatlı
 * add-on SİLİNMİYOR, yerine AYNI ÜRÜNÜN NORMAL FİYATLI hâli konuyor — müşteri
 * ürünü kaybetmesin, sadece indirimi kaybetsin. 0₺ hediye ise silinir (tek
 * başına sipariş edilmesin). Ekran Dawn'ın kendi `cart-drawer.renderContents`
 * çağrısıyla yenilenir (assets/cart-drawer.js:79) — çekmece açık kalır.
 *
 * v1.7.0 — DÜZELTME: canlı tema **Dawn 16.0.0** (config/settings_schema.json ile
 * doğrulandı). v1.4–v1.6 yanlışlıkla Horizon işaretlerini kullanıyordu
 * (`.cart-items__remove`, `shopify:cart:lines-update`, `cart-drawer-section`) —
 * hiçbiri Dawn'da yok, o yüzden ekran güncellenmiyordu. Dawn'ın gerçek yapısı:
 * miktar girdisi `#Drawer-quantity-N` / `#Quantity-N` üzerinde
 * `data-quantity-line-key` + `data-quantity-variant-id`, silme düğmesi
 * `<cart-remove-button data-index="N">` içindeki `button`
 * (snippets/cart-drawer.liquid:319-377). Bölüm kimlikleri:
 * cart-drawer · cart-icon-bubble · cart-live-region-text (assets/cart.js:144).
 *
 * v1.6.0 — ÖNCE TEMANIN KENDİ SİLME BUTONU tıklanıyor
 * v1.5'te sunucu tarafı siliniyordu (log: "silme yanıtı 200") ama satır ekranda
 * kalıyordu — Horizon satırları kendi `morphSection` akışıyla çiziyor ve dışarıdan
 * basılan HTML'i benimsemiyor. Buton tıklanınca UI + sunucu birlikte güncelleniyor.
 * Buton yoksa (çekmece hiç render edilmemişse) eski fetch yolu yedek kalıyor.
 *
 * v1.5.0 — TEŞHİS + dayanıklılık: `window.__veloccoGiftGuard` sürüm işareti,
 * `?guardlog=1` ile konsol günlüğü, DOMContentLoaded geçmişse hemen çalışma,
 * ilk 6 saniye 1.5 sn'de bir tekrar kontrol (modül yükleme sırası ve geç
 * hidrasyon için). Silme isteğinin sonucu da günlüğe yazılıyor.
 *
 * v1.4.0 — Horizon'un kendi güncelleme sözleşmesi kullanılıyor: sepet bileşenleri
 * `shopify:cart:lines-update` olayını dinliyor ve `event.promise` ÇÖZÜLDÜĞÜNDE
 * `detail.sections[sectionId]` HTML'ini `morphSection` ile basıyor
 * (assets/component-cart-items.js:340). Promise'siz CustomEvent hiçbir şey
 * yapmıyordu — satır ekranda kalıyordu. Ayrıca `sections` artık tema gibi
 * virgüllü STRING gönderiliyor.
 *
 * v1.3.0 — reload TAMAMEN kaldırıldı (v1.2'de bölüm bulunamayınca yine
 * yenileniyordu): Horizon'un çekmecesi layout'ta `{% render 'cart-drawer' %}` ile
 * basılıyor, SRA hedefi `cart-drawer-section` — o id artık sabit isteniyor.
 * Basılamazsa sayfa yenilenmez; MENAKS eklentisinin kendi fetch kancası
 * (`hookFetch` → `refresh`) zaten /cart/update sonrası çekmeceyi çiziyor.
 *
 * v1.2.0 — sayfa artık YENİLENMİYOR: sepet bölümleri `sections` ile yerinde
 * yeniden çiziliyor, böylece çekmece açık kalıyor (Mehmet, 2026-09-24).
 * MENAKS'ın `cartPost` yolundaki desenin aynısı. Bölüm bulunamazsa son çare reload.
 *
 * v1.1.0 — aynı koruma ADD-ON ürününe de uygulandı: "Evening Blackout Mask
 * (add-on)" yarı fiyatlı sepet-içi teklif; ana ürün olmadan tek başına
 * alınamamalı (Mehmet, 2026-09-24). Ana ürün yoksa sepetten düşer.
 */
(function () {
  var VERSION = '2.0.0';
  window.__veloccoGiftGuard = VERSION;
  var LOG = /(?:\?|&)guardlog=1/.test(window.location.search);
  function log() {
    if (!LOG) return;
    try { console.log.apply(console, ['[gift-guard ' + VERSION + ']'].concat([].slice.call(arguments))); } catch (e) {}
  }

  var MAIN_VARIANTS = [56539458601265, 56539458634033, 56539458666801];  // Hearthwrap bornoz + Winter Warm Set
  var GIFT_VARIANTS = [56435365085489, 56229652300081]; // Ear Drops (Gift) + eski gerçek varyant
  // Yarı fiyatlı sepet-içi teklif → ana ürün yoksa normal fiyatlı karşılığı.
  var ADDON_TO_FULL = {
    '56539364360497': 56539364163889,  // Socks (add-on) Red S/M     → normal
    '56539364393265': 56539364196657,  // Socks (add-on) Red L/XL    → normal
    '56539364426033': 56539364229425,  // Socks (add-on) Black S/M   → normal
    '56539364458801': 56539364262193,  // Socks (add-on) Black L/XL  → normal
    '56539364524337': 56539364491569,  // Hand Warmers (add-on)      → normal
    '56539364589873': 56539364557105   // Power Bank (add-on)        → normal
  };
  var busy = false;

  function isGift(item) {
    if (GIFT_VARIANTS.indexOf(Number(item.variant_id)) > -1) return true;
    var p = item.properties || {};
    return String(p._gift || '') === 'true';
  }

  function fullPriceVariant(item) {
    return ADDON_TO_FULL[String(item.variant_id)] || 0;
  }

  /** Sepet boşaldıysa Dawn'ın boş-çekmece görünümünü geri getir. */
  function syncEmptyState(res) {
    var empty = res && Number(res.item_count || 0) === 0;
    ['cart-drawer', 'cart-drawer-items'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (!n) return;
      if (empty) n.classList.add('is-empty');
      else n.classList.remove('is-empty');
    });
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) {
      if (empty) inner.classList.add('is-empty');
      else inner.classList.remove('is-empty');
    }
    return empty;
  }

  /** Dawn çekmecesini kendi yoluyla yenile (çekmece açık kalır). */
  function repaint(res) {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && res && res.sections) {
        drawer.renderContents(res);
        return true;
      }
    } catch (e) { log('renderContents hata', e && e.message); }
    // Yedek: bölümleri doğrudan bas.
    var painted = false;
    if (res && res.sections) {
      var map = { 'cart-drawer': '#CartDrawer', 'cart-icon-bubble': '#cart-icon-bubble' };
      Object.keys(map).forEach(function (id) {
        var html = res.sections[id];
        var host = document.querySelector(map[id]);
        if (!html || !host) return;
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector(map[id]) || doc.querySelector('.shopify-section');
          if (fresh) { host.innerHTML = fresh.innerHTML; painted = true; }
        } catch (e) {}
      });
    }
    return painted;
  }

  function check() {
    if (busy) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) return;
        var hasMain = false, updates = {}, changed = 0, notes = [];
        for (var i = 0; i < c.items.length; i++) {
          if (MAIN_VARIANTS.indexOf(Number(c.items[i].variant_id)) > -1) { hasMain = true; break; }
        }
        log('sepet', c.items.map(function (i) { return i.variant_id + '×' + i.quantity; }).join(', '),
            '| ana ürün:', hasMain);
        if (hasMain) return;

        for (var j = 0; j < c.items.length; j++) {
          var it = c.items[j];
          var full = fullPriceVariant(it);
          if (full) {
            updates[String(it.key || it.variant_id)] = 0;      // indirimli satır çıkar
            updates[String(full)] = (updates[String(full)] || 0) + it.quantity;  // normal fiyatlı gir
            changed++; notes.push('add-on → normal fiyat');
          } else if (isGift(it)) {
            updates[String(it.key || it.variant_id)] = 0;      // 0₺ hediye tek başına kalmasın
            changed++; notes.push('hediye silindi');
          }
        }
        if (!changed) return;

        busy = true;
        log('düzeltiliyor:', notes.join(' · '));
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            updates: updates,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          }),
          credentials: 'same-origin'
        }).then(function (r) { log('yanıt', r.status); return r.ok ? r.json() : null; })
          .then(function (res) {
            var painted = repaint(res);
            var empty = syncEmptyState(res);   // renderContents sonrası: sınıf geri konur
            log('ekran yenilendi:', painted, '| sepet boş:', empty);
            busy = false;
          })
          .catch(function () { busy = false; });
      })
      .catch(function () {});
  }

  // Sepeti değiştiren her isteğin ARDINDAN kontrol et.
  if (window.fetch) {
    var orig = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var href = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(href)) p.then(function () { setTimeout(check, 250); });
      return p;
    };
  }

  function boot() {
    check();
    var tries = 0;
    var t = setInterval(function () { tries++; check(); if (tries >= 4) clearInterval(t); }, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  log('yüklendi');
})();
